import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'

const CuentasCobrar = lazy(() => import('./view/CuentasCobrar'))
const PagarCtaCobrar = lazy(() => import('./view/PagarCtaCobrar'))
const PagarCtaCobrarMovimiento = lazy(
  () => import('./view/PagarCtaCobrarMovimiento/PagarCtaCobrarMovimiento'),
)

export const cuentasCobrarRoutesMap = {
  gestion: {
    path: '/cobrar/gestion',
    name: 'Gestión',
    action: 'GESTION',
  },
  pagar: {
    path: '/cobrar/pagar',
    name: 'Pagar cuenta',
    action: 'PAGAR_CUENTA',
  },
  pagarCuentaCobrar: {
    path: '/cobrar/pagar/movimiento/:id',
    name: 'Movimientos',
    action: 'MOVIMIENTOS',
  },
}

const cuentasCobrarRoutes = [
  {
    path: cuentasCobrarRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <CuentasCobrar />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: cuentasCobrarRoutesMap.pagar.path,
    element: (
      <OperacionesProvider>
        <PagarCtaCobrar />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: cuentasCobrarRoutesMap.pagarCuentaCobrar.path,
    element: (
      <OperacionesProvider>
        <PagarCtaCobrarMovimiento />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]

export default cuentasCobrarRoutes
